module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_arrow_left-4efdcfd828325a89d817aa91ad55d7a8.svg";